"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const font_1 = require("../../typings/font");
function convertSingleTypography(typography) {
    const { style, tracking, size, lineHeight, ...rest } = typography;
    const output = {
        size: `${size}px`,
        style: style.toLowerCase() in font_1.IFontStyleWeb
            ? font_1.IFontStyleWeb[style.toLowerCase()]
            : font_1.IFontStyleWeb.normal,
        tracking: `${tracking}px`,
        lineHeight: `${lineHeight}px`,
        ...rest,
    };
    return output;
}
exports.default = convertSingleTypography;
//# sourceMappingURL=convert-single-typography.js.map